import * as storeListApi from "../backend/store/storeListApi.js";

export default class {
  constructor() {
    this.state = {
      items: [],
      pagination: {
        page: 1,
      },
      filter: null,
      filters: [],
      columns: [],
      savedSettings: [],
      selectedSetting: null,
      loading: false,
      quickFilter: null,
      isShared: false,
      sort: [],
      actions: [],
      defaultFilter: null,
    };

    this.getters = {
      items(state) {
        return state.items;
      },
      pagination(state) {
        return state.pagination;
      },
      filter(state) {
        return state.filter;
      },
      filters(state) {
        return state.filters;
      },
      columns(state) {
        return state.columns;
      },
      savedSettings(state) {
        return state.savedSettings;
      },
      selectedSetting(state) {
        return state.selectedSetting;
      },
      loading(state) {
        return state.loading;
      },
      quickFilter(state) {
        return state.quickFilter;
      },
      isShared(state) {
        return state.isShared;
      },
      sort(state) {
        return state.sort;
      },
      allActionsRegistered(state) {
        if (
          state.actions.includes("pagging") ||
          state.actions.includes("filter") ||
          state.actions.includes("rowsCount") ||
          state.actions.includes("settings")
        ) {
          return true;
        } else {
          return false;
        }
      },
      defaultFilter(state) {
        return state.defaultFilter;
      },
    };

    this.mutations = {
      setItems(state, items) {
        state.items = items;
      },
      setPagination(state, pagination) {
        state.pagination = pagination;
      },
      setFilter(state, filter) {
        state.filter = filter;
        state.pagination.page = 1;
      },
      setFilters(state, filters) {
        state.filters = filters;
      },
      setQuickFilter(state, filter) {
        state.quickFilter = filter;
      },
      clearQuickFilter(state) {
        state.quickFilter = null;
      },
      clearFilterValue(state, filterValue) {
        if (
          filterValue.type === "decimal" ||
          filterValue.type === "int" ||
          filterValue.type === "date"
        ) {
          filterValue.valueFrom = null;
          filterValue.valueTo = null;
        } else {
          filterValue.value = null;
        }
        state.pagination.page = 1;
      },
      setColumns(state, columns) {
        state.columns = columns;
      },
      setSavedSettings(state, savedSettings) {
        state.savedSettings = savedSettings;
      },
      setSelectedSetting(state, selected) {
        state.selectedSetting = selected;
      },
      setLoading(state, loading) {
        state.loading = loading;
      },
      setIsShared(state, isShared) {
        state.isShared = isShared;
      },
      defaultIsShared(state) {
        state.isShared = false;
      },
      setSort(state, sort) {
        state.sort = sort;
        state.pagination.page = 1;
      },
      registerAction(state, action) {
        if (
          action === "rowsCount" &&
          state.actions.includes("filtersLoading")
        ) {
          state.actions.push(action);
        } else if (action !== "rowsCount" && !state.actions.includes(action)) {
          state.actions.push(action);
        }
      },
      setDefaultFilter(state, value) {
        return state.defaultFilter = value;
      },
    };

    this.actions = {
      async applyQuickFilter({ getters, commit }, id) {
        const res = await storeListApi.getSavedFilters(id);
        const copy = {};
        for (const prop in getters.defaultFilter) {
          if (prop === "id") {
            copy.id = res.data.Filter.Id;
            continue;
          }
          if (Object.prototype.hasOwnProperty.call(res.data.Filter, prop)) {
            copy[prop] = { ...res.data.Filter[prop] };
          } else {
            copy[prop] = { ...getters.defaultFilter[prop] };
          }
        }
        commit("setFilter", copy);
        commit("setIsShared", res.data.IsShared);
        commit("setQuickFilter", getters.filters.find(f => f.id === id));
      },
      clearQuickFilter({ commit, getters }) {
        commit("clearQuickFilter");
        commit("defaultIsShared");
        for (const filterItem in getters.filter) {
          commit("clearFilterValue", getters.filter[filterItem]);
        }
      },
      changeFilter({ commit }, filterItem) {
        commit("clearQuickFilter");
        commit("defaultIsShared");
        if (filterItem) {
          commit("clearFilterValue", filterItem);
        }
      },
    };
  }
}
